module.exports = __webpack_public_path__ + "img/oeilb.70152f24.svg";